import { deleteApiCaller, getApiCaller, postFormDataApiCaller, putApiCaller, putFormDataApiCaller } from "../apiCaller";

export const getAudioCategories = async (currentPage, itemsPerPage, search, tree = false, parentId = undefined) => {
    const treeParam = tree ? '&tree=true' : '';
    let url = `audio-category/get-all?page=${currentPage}&limit=${itemsPerPage}&search=${search}${treeParam}&includeHidden=true`;
    if (parentId !== undefined) {
        url += `&parentId=${parentId}`;
    }
    const response = await getApiCaller(url);
    return response;
}

export const getAudioCategoriesDropdown = async () => {
    const response = await getApiCaller("audio-category/dropdown");
    return response;
}

export const getAudioCategoryById = async (id) => {
    const response = await getApiCaller(`audio-category/${id}`);
    return response;
}

export const getAudioByCategoryId = async (id, currentPage, itemsPerPage) => {
    const response = await getApiCaller(`audio-category/${id}/audio?page=${currentPage}&limit=${itemsPerPage}&includeHidden=true`);
    return response;
}

export const addAudioCategory = async (payload) => {
    const response = await postFormDataApiCaller("audio-category/create", payload);
    return response;
}

export const updateAudioCategory = async (id, payload) => {
    const response = await putFormDataApiCaller(`audio-category/update/${id}`, payload);
    return response;
}

export const deleteAudioCategory = async (id) => {
    const response = await deleteApiCaller(`audio-category/delete/${id}`);
    return response;
}

export const audioCategorySequence = async (payload) => {
    const response = await putApiCaller("audio-category/sequence", payload);
    return response;
}

export const getCategoryChildren = async (id) => {
    const response = await getApiCaller(`audio-category/${id}/children`);
    return response;
}

export const getCategoryAncestors = async (id) => {
    const response = await getApiCaller(`audio-category/${id}/ancestors`);
    return response;
}

export const swapAudioCategoryWithPage = async (payload) => {
    const response = await putApiCaller("audio-category/swap-page", payload);
    return response;
}
